import React, { useState, useEffect } from 'react'
import TWControls from 'components/controls/TWControls'
import { Form, useForm } from 'components/controls/useForm'

const BulkLocationEditPopup = ({ editLocation, recordForEdit }) => {
	const initialValues = {
		...recordForEdit,
	}

	const validate = () => {
		let temp = { ...errors }
		temp.assetName = values.assetName ? '' : 'This field is required.'

		setErrors({
			...temp,
		})

		return Object.values(temp).every(x => x === '')
	}

	const { values, setValues, errors, setErrors, handleInputChange, resetForm } = useForm(initialValues, true, validate)

	const submitHandler = () => {
		console.log(`values: `, values)

		if (validate()) {
			editLocation(values)
		}
	}

	useEffect(() => {
		if (recordForEdit != null) setValues({ ...recordForEdit })
	}, [recordForEdit, setValues])

	return (
		<div className="max-w-[960px] mx-auto">
			<Form onSubmit={submitHandler}>
				<div className="grid grid-cols-12 gap-4">
					<div className="col-span-6">
						<TWControls.Input
							size="small"
							name="assetName"
							label="Location Name"
							value={values.assetName}
							onChange={handleInputChange}
						/>
					</div>
					<div className="col-span-6">
						<TWControls.Input
							size="small"
							name="address"
							label="Address"
							value={values.address}
							onChange={handleInputChange}
						/>
					</div>

					<div className="col-span-6">
						<TWControls.Input size="small" name="city" label="City" value={values.city} onChange={handleInputChange} />
					</div>

					<div className="col-span-3">
						<TWControls.Input
							size="small"
							name="stateProvince"
							label="State/Prov"
							value={values.stateProvince}
							onChange={handleInputChange}
						/>
					</div>

					<div className="col-span-3">
						<TWControls.Input
							size="small"
							name="postalCode"
							label="Postal Code"
							value={values.postalCode}
							onChange={handleInputChange}
						/>
					</div>
					<div className="col-span-12">
						<div className="flex flex-col items-center justify-center p-4">
							<TWControls.Button size="small" type="submit" text="Update" />
						</div>
					</div>
				</div>
			</Form>
		</div>
	)
}

export default BulkLocationEditPopup
